module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-1.3aad6815.svg";